import React, { useEffect, useState } from 'react';
import {
  IconButton,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
  Checkbox,
} from '@material-ui/core';
import MomentUtils from '@date-io/moment';
import EditIcon from '@mui/icons-material/Edit';
import moment from 'moment';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import WatchLaterIcon from '@mui/icons-material/WatchLater';
import { KeyboardTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { handleValidation } from '../../utils/formUtils';
import { ALL_DAY, DAYS } from '../../constants/restaurantConst';

const CustomHours = (props) => {
  const {
    setFormData,
    formData,
    customTime,
    setCustomTime,
    validate,
    tabValue,
    customTimeError,
    setCustomTimeError,
  } = props;

  const [isEditCustomTime, setIsEditCustomTime] = useState({
    isEdit: false,
    customindex: -1,
  });
  const [days, setDays] = useState();
  const [lastCustomTime, setLastCustomTime] = useState({
    from: formData?.from?.value,
    to: formData?.to?.value,
  });

  const resetDaysData = () => {
    const defaultDays = DAYS.map((daysValue, ndx) => {
      return {
        id: ndx + 1,
        name: daysValue.name,
        ischecked: false,
        from: null,
        to: null,
      };
    });
    setDays(defaultDays);
  };

  useEffect(() => {
    resetDaysData();
  }, []);

  const setErrorMessage = (status, message) => {
    setCustomTimeError({ status: status, message: message });
  };

  const onChangeAvailableOn = (e) => {
    resetDaysData();
    setErrorMessage(false, '');
    if (!isEditCustomTime.isEdit) {
      const is24X7 = customTime.some((currentData) => {
        const isEveryDay = currentData.days.some((currDays) => {
          if (
            currDays === 'Everyday' &&
            (currentData.from === 'all day' || currentData.to === 'all day')
          )
            return true;
          return false;
        });
        return isEveryDay;
      });
      if (is24X7) {
        setErrorMessage(true, 'Please Remove all current timing');
        return false;
      }
    }
    const availableOn = {
      value: e.target.value,
      fieldName: 'availableOn',
      errors: {},
      validations: [],
      tab: 1,
    };
    setFormData({ availableOn });
  };

  const handleTimePickerChange = (date, value, type) => {
    setErrorMessage(false, '');

    const currTimeField = { ...formData[type] };
    currTimeField.value = value;
    handleValidation(currTimeField);

    if (formData.availableOn === 'everyDay') return false;
    const daysArray = [...days];
    const checkedDayArray = daysArray.filter((d) => d.ischecked === true);
    checkedDayArray.map((checkedKey) => (checkedKey[type] = value));
    const startTime = formData?.from?.value;
    const endTime = formData?.to?.value;

    if (checkedDayArray?.length === 1) {
      const isInvalidTime =
        (type === 'from' && endTime < value) || (type === 'to' && startTime > value);

      if (isInvalidTime) {
        currTimeField.errors.validTime = 'Invalid Time';
      }
    }

    setFormData({
      [type]: currTimeField,
    });
  };

  const setErrorText = (type) => {
    if (formData[type].errors.required) return formData[type].errors.required;
    if (formData[type].errors.validTime) return formData[type].errors.validTime;
    return null;
  };

  const removeEveryDay = (ndx) => {
    if (ndx > -1) customTime.splice(ndx, 1);
  };

  const setDayId = (selectedDay) => {
    if (selectedDay === 'Monday') return 1;
    if (selectedDay === 'Tuesday') return 2;
    if (selectedDay === 'Wednesday') return 3;
    if (selectedDay === 'Thursday') return 4;
    if (selectedDay === 'Friday') return 5;
    if (selectedDay === 'Saturday') return 6;
    if (selectedDay === 'Sunday') return 7;
  };

  const validateCustomTime = () => {
    if (formData.hours.value === 'allTime') {
      return true;
    }
    const checkedDays = days?.filter((day) => day?.ischecked);

    if (checkedDays?.length === 1) {
      const startTime = formData?.from?.value;
      const endTime = formData?.to.value;
      if (startTime && endTime && startTime > endTime) {
        setErrorMessage(true, 'Invalid Time');
        return false;
      }
    }

    const hasConflict = checkedDays.some((day) => {
      return customTime.some((time, index) => {
        if (index === isEditCustomTime?.customindex) return false;

        if (!time?.days?.includes(day?.name)) return false;

        if (time.from === ALL_DAY || formData?.hours?.value === 'allTime') {
          return true;
        }

        const existingStart = moment(time?.from, 'HH:mm');
        const existingEnd = moment(time?.to, 'HH:mm');
        const newStart = moment(formData?.from.value, 'HH:mm');
        const newEnd = moment(formData?.to?.value, 'HH:mm');

        return (
          newStart?.isBetween(existingStart, existingEnd, undefined, '[]') ||
          newEnd?.isBetween(existingStart, existingEnd, undefined, '[]') ||
          existingStart?.isBetween(newStart, newEnd, undefined, '[]') ||
          existingEnd?.isBetween(newStart, newEnd, undefined, '[]')
        );
      });
    });

    if (hasConflict) {
      setErrorMessage(true, 'One or more selected days already have a schedule');
      return false;
    }
    return true;
  };

  const onAddCustomTime = async () => {
    const isValid = validate(tabValue);
    const isCustomTimeValid = validateCustomTime();
    if (!isValid || !isCustomTimeValid) return false;
    setErrorMessage(false, '');
    if (isEditCustomTime.isEdit) {
      const customTimeData = [...customTime];
      const getDay = await days.filter((d) => d.ischecked === true);
      if (getDay.length === 0) {
        customTimeData[isEditCustomTime.customindex].days = ['Everyday'];
        if (formData?.hours?.value === 'allTime') {
          customTimeData[isEditCustomTime?.customindex].to = ALL_DAY;
          customTimeData[isEditCustomTime?.customindex].from = ALL_DAY;
        } else {
          customTimeData[isEditCustomTime?.customindex].to = formData.to.value;
          customTimeData[isEditCustomTime?.customindex].from = formData?.from?.value;
        }
      } else {
        customTimeData[isEditCustomTime.customindex].days = getDay.map((dayName) => dayName.name);
        if (formData?.hours?.value === 'allTime') {
          customTimeData[isEditCustomTime?.customindex].to = ALL_DAY;
          customTimeData[isEditCustomTime?.customindex].from = ALL_DAY;
        } else {
          customTimeData[isEditCustomTime?.customindex].to = formData?.to?.value;
          customTimeData[isEditCustomTime?.customindex].from = formData?.from?.value;
        }
      }
      setCustomTime(customTimeData);
      setIsEditCustomTime({ isEdit: false, customindex: -1 });
    } else {
      const availableOn = formData.availableOn.value;
      const hours = formData.hours.value;
      let dayArray = [];
      const getcheckedDay = await days.filter((d) => d.ischecked === true);
      if (availableOn === 'custom' && hours === 'custom') {
        if (getcheckedDay.length === 0) {
          setErrorMessage(true, 'Please select days');
          return false;
        }
        const checkSameDay = customTime.some((currentDays) => {
          let hasSameDay = false;
          if (currentDays.days && currentDays.days.length > 0) {
            hasSameDay = currentDays.days.some((dayName) => {
              const checkSameDayName = getcheckedDay.find((e) => e.name === dayName);
              if (checkSameDayName) {
                if (currentDays.from === 'all day' || checkSameDayName.to === 'all day')
                  return true;
                if (
                  currentDays.to === checkSameDayName.to ||
                  currentDays.from === checkSameDayName.from
                )
                  return true;
                const selectedToDate = moment(checkSameDayName.to, 'HH:mm');
                const existingToDate = moment(currentDays.to, 'HH:mm');
                const selectedFromDate = moment(checkSameDayName.from, 'HH:mm');
                const existingFromDate = moment(currentDays.from, 'HH:mm');
                const beforeTo = selectedToDate.isBetween(existingFromDate, existingToDate);
                const beforeFrom = selectedFromDate.isBetween(existingFromDate, existingToDate);
                if (beforeTo || beforeFrom) return true;
                return false;
              }
              return false;
            });
            return hasSameDay;
          }
        });
        if (checkSameDay) {
          setErrorMessage(true, 'Same day with same time already added please change time');
          return false;
        }
        customTime.map(async () => {
          const geteveryDay = customTime.findIndex((x) => x.days.find((d) => d === 'Everyday'));
          if (geteveryDay > -1) await removeEveryDay(geteveryDay);
        });
        dayArray.push({
          days: getcheckedDay.map((dayName) => dayName.name),
          to: getcheckedDay[0].to,
          from: getcheckedDay[0].from,
        });
        setCustomTime([...customTime, ...dayArray]);
      } else if (availableOn === 'custom' && hours === 'allTime') {
        if (getcheckedDay.length === 0) {
          setErrorMessage(true, 'Please select days');
          return false;
        }
        customTime.map(() => {
          const isEveryDay = customTime.findIndex((x) => x.days.find((d) => d === 'Everyday'));
          removeEveryDay(isEveryDay);
        });
        const checkSameDays = customTime.some((customDay) => {
          const sameDay = customDay.days.some((currDay) => {
            const isDayExist = getcheckedDay.findIndex((dayName) => dayName.name === currDay);
            if (isDayExist > -1) return true;
            return false;
          });
          return sameDay;
        });
        if (checkSameDays) {
          setErrorMessage(true, 'Day already selected please select a different day');
          return false;
        }
        const dayWithId = getcheckedDay.map((dayElement) => {
          return { name: dayElement.name, id: setDayId(dayElement) };
        });
        const sortDay = dayWithId.sort((currDay, nextDay) => currDay?.id - nextDay?.id);
        const currDayTime = [...customTime];
        currDayTime.push({
          days: sortDay.map((dayName) => dayName.name),
          from: ALL_DAY,
          to: ALL_DAY,
        });
        setCustomTime(currDayTime);
      } else if (availableOn === 'everyDay' && hours === 'custom') {
        const checkSameTime = customTime.some((currentDays) => {
          if (currentDays.to === formData.to.value || currentDays.from === formData.from.value)
            return true;
          const selectedToDate = moment(formData.to.value, 'HH:mm');
          const existingToDate = moment(currentDays.to, 'HH:mm');
          const selectedFromDate = moment(formData.from.value, 'HH:mm');
          const existingFromDate = moment(currentDays.from, 'HH:mm');
          const beforeTo = existingToDate.isBetween(selectedFromDate, selectedToDate);
          const beforeFrom = existingFromDate.isBetween(selectedFromDate, selectedToDate);
          if (beforeTo || beforeFrom) return true;
          return false;
        });
        if (checkSameTime) {
          setErrorMessage(true, 'Same day with same time already added please change time');
          return false;
        }
        DAYS.map((allDays) => {
          const checkCustomDays = customTime.findIndex((x) =>
            x.days.find((d) => d === allDays.name),
          );
          removeEveryDay(checkCustomDays);
        });
        dayArray.push({
          days: ['Everyday'],
          from: formData.from.value,
          to: formData.to.value,
        });
        setCustomTime([...customTime, ...dayArray]);
      } else if (availableOn === 'everyDay' && hours === 'allTime') {
        const exists = customTime?.some(
          (time) =>
            time?.days?.includes('Everyday') && time.from === ALL_DAY && time.to === ALL_DAY,
        );
        if (exists) {
          setErrorMessage(true, 'Same day with same time already added, Please change time');
          return false;
        }
        dayArray = [
          {
            days: ['Everyday'],
            from: ALL_DAY,
            to: ALL_DAY,
          },
        ];
        setCustomTime(dayArray);
      }
    }

    resetDaysData();
  };

  const onClickEditTime = (event, dayObj, dayNdx) => {
    event.preventDefault();
    const availableOn = { ...formData.availableOn };
    const hours = { ...formData.hours };
    if (dayObj.days[0] === 'Everyday' && (dayObj.from === 'all day' || dayObj.to === 'all day')) {
      availableOn.value = 'everyDay';
      hours.value = 'allTime';
    } else if (dayObj.days.length > 0 && dayObj.from === 'all day' && dayObj.to === 'all day') {
      availableOn.value = 'custom';
      hours.value = 'allTime';
    } else if (
      dayObj.days[0] === 'Everyday' &&
      dayObj.from !== 'all day' &&
      dayObj.to !== 'all day'
    ) {
      availableOn.value = 'everyDay';
      hours.value = 'custom';
    } else if (formData.availableOn.value !== 'custom' || formData.hours.value !== 'custom') {
      availableOn.value = 'custom';
      hours.value = 'custom';
    }
    setFormData({ availableOn, hours });
    setIsEditCustomTime({ isEdit: true, customindex: dayNdx });
    const daysData = [...days];
    if (dayObj.days && dayObj.days.length > 0) {
      dayObj.days.map((selectedDays) => {
        const pos = daysData.findIndex((i) => i.name === selectedDays);
        if (pos > -1) {
          daysData[pos].ischecked = true;
          daysData[pos].from = dayObj.from;
          daysData[pos].to = dayObj.to;
        }
      });
      setDays(daysData);
      if (dayObj.from !== 'all day' && dayObj.to !== 'all day') {
        const from = { ...formData.from };
        const to = { ...formData.to };
        from.value = dayObj.from;
        to.value = dayObj.to;
        setFormData({ from, to });
      }
    }
  };

  const onDeleteCustomTime = (event, dayNdx) => {
    setErrorMessage(false, '');
    event.preventDefault();
    const ct = [...customTime];
    ct.splice(dayNdx, 1);
    setCustomTime(ct);
  };

  const handleDaysChange = (e, dayndx) => {
    const currDays = [...days];
    currDays[dayndx].ischecked = e.target.checked;
    currDays[dayndx].from = formData.from.value ? formData.from.value : null;
    currDays[dayndx].to = formData.to.value ? formData.to.value : null;
    setDays(currDays);
  };

  const onChangeHours = (e) => {
    setErrorMessage(false, '');
    if (!isEditCustomTime.isEdit) {
      const is24X7 = customTime.some((currentData) => {
        const isEveryDay = currentData.days.some((currDays) => {
          if (
            currDays === 'Everyday' &&
            (currentData.from === 'all day' || currentData.to === 'all day')
          )
            return true;
          return false;
        });
        return isEveryDay;
      });
      if (is24X7) {
        setErrorMessage(true, 'Please Remove all current timing');
        return false;
      }
    }
    const from = { ...formData?.from };
    const to = { ...formData?.to };
    const hours = { ...formData?.hours };

    if (e?.target?.value === 'allTime') {
      setLastCustomTime({ from: from?.value, to: to?.value });
      from.validations = [];
      to.validations = [];
      from.value = ALL_DAY;
      to.value = ALL_DAY;
    } else {
      from.validations = ['required', 'validTime'];
      to.validations = ['required', 'validTime'];
      if (lastCustomTime?.from && lastCustomTime?.to) {
        from.value = lastCustomTime?.from;
        to.value = lastCustomTime?.to;
      }
    }
    hours.value = e?.target?.value;
    setFormData({ hours, from, to });
  };

  const daysConteniousCheck = (currDays) => {
    const firstIndex = DAYS.findIndex(
      (day) => day.name.toLowerCase() === currDays[0].toLowerCase(),
    );
    for (let i = 0; i < currDays.length; i++) {
      if (currDays[i].toLowerCase() !== DAYS[(i + firstIndex) % 7].name.toLowerCase()) return false;
    }
    return true;
  };

  const renderDays = (currDays) => {
    if (currDays) {
      if (currDays.length > 2) {
        const areDaysContenious = daysConteniousCheck(currDays);
        if (areDaysContenious) {
          const tempdays = [currDays[0], currDays[currDays.length - 1]];
          return tempdays
            .map((tempDay) => tempDay.charAt(0).toUpperCase() + tempDay.slice(1, 3).toLowerCase())
            .join(' to ');
        }
        return currDays
          .map((day) => day.charAt(0).toUpperCase() + day.slice(1, 3).toLowerCase())
          .join(', ');
      } else {
        return currDays[0] === 'Everyday'
          ? 'Everyday'
          : currDays
              .map((day) => day.charAt(0).toUpperCase() + day.slice(1, 3).toLowerCase())
              .join(', ');
      }
    }
  };

  const setTimeFormat = (time) => {
    if (time === 'all day' || time === '24*7') return time;
    return moment(time, 'HH:mm').format('hh:mm A');
  };

  return (
    <>
      <h4 className='tab-title'>Available On</h4>
      <div className='row'>
        <div className='custom-upload col-md-12'>
          <RadioGroup
            row
            aria-label={formData.availableOn.fieldName}
            onChange={(e) => {
              onChangeAvailableOn(e);
            }}
            value={formData.availableOn.value}
            name={formData.availableOn.fieldName}
            className='document-type mb-3'
          >
            <FormControlLabel
              value='everyDay'
              control={<Radio color='primary' />}
              label='Everyday'
              className='me-5'
            />
            <FormControlLabel value='custom' control={<Radio color='primary' />} label='Custom' />
          </RadioGroup>
        </div>
        {formData.availableOn.value === 'custom' && (
          <div className='custom-upload mb-5 col-md-12'>
            {days &&
              days.length > 0 &&
              days.map((dayKey, dayNdx) => (
                <FormControlLabel
                  className='document-type'
                  key={dayKey.id}
                  control={
                    <Checkbox
                      color='primary'
                      checked={dayKey.ischecked}
                      onChange={(e) => handleDaysChange(e, dayNdx)}
                      name='days'
                    />
                  }
                  label={dayKey.name}
                />
              ))}
          </div>
        )}
      </div>
      <h4 className='tab-title'>Hours</h4>
      <div className='custom-upload col-md-12'>
        <RadioGroup
          row
          aria-label={formData.availableOn.fieldName}
          onChange={(e) => {
            onChangeHours(e);
          }}
          value={formData.hours.value}
          name={formData.hours.fieldName}
          className='document-type'
        >
          <FormControlLabel
            value='allTime'
            control={<Radio color='primary' />}
            label='24 * 7'
            className='me-5'
          />
          <FormControlLabel value='custom' control={<Radio color='primary' />} label='Custom' />
        </RadioGroup>
      </div>
      {formData.hours.value === 'custom' && (
        <div>
          <div className='row'>
            <div className='col-md-6'>
              <MuiPickersUtilsProvider utils={MomentUtils}>
                <KeyboardTimePicker
                  variant='inline'
                  margin='normal'
                  id='from'
                  label='From'
                  className='col-md-12'
                  ampm={false}
                  format='HH:mm'
                  required={true}
                  inputValue={formData.from.value}
                  onChange={(date, value) => handleTimePickerChange(date, value, 'from')}
                  error={
                    formData.from?.errors.required || formData.from?.errors.validTime ? true : false
                  }
                  helperText={setErrorText('from')}
                  keyboardIcon={<WatchLaterIcon />}
                />
              </MuiPickersUtilsProvider>
            </div>
            <div className='col-md-6'>
              <MuiPickersUtilsProvider utils={MomentUtils}>
                <KeyboardTimePicker
                  variant='inline'
                  margin='normal'
                  id='to'
                  label='To'
                  className='col-md-12'
                  ampm={false}
                  format='HH:mm'
                  required={true}
                  inputValue={formData.to.value}
                  onChange={(date, value) => handleTimePickerChange(date, value, 'to')}
                  error={
                    formData.to?.errors.required || formData.to?.errors.validTime ? true : false
                  }
                  helperText={setErrorText('to')}
                  keyboardIcon={<WatchLaterIcon />}
                />
              </MuiPickersUtilsProvider>
            </div>
          </div>
        </div>
      )}
      <Button
        variant='outlined'
        color='primary'
        onClick={(e) => onAddCustomTime(e)}
        size='large'
        className='me-3 mt-4 mb-4'
      >
        Add
      </Button>
      {customTimeError.status && <p style={{ color: 'red' }}>{customTimeError.message}</p>}
      {customTime && customTime.length > 0 && (
        <div className='col-md-10'>
          {customTime.map((timeKey, timeNdx) => (
            <div className='custom-daytime-box d-flex justify-content-between' key={timeNdx}>
              <div className='row w-75'>
                <div className='col-md-5 text'>{renderDays(timeKey.days)}</div>
                <div className='col-md-7 text'>
                  {setTimeFormat(timeKey.from)} - {setTimeFormat(timeKey.to)}
                </div>
              </div>
              <div>
                <IconButton
                  aria-label='edit'
                  disabled={isEditCustomTime.isEdit}
                  onClick={(e) => onClickEditTime(e, timeKey, timeNdx)}
                >
                  <EditIcon fontSize='small' />
                </IconButton>
                <IconButton
                  aria-label='delete'
                  disabled={isEditCustomTime.isEdit}
                  onClick={(e) => onDeleteCustomTime(e, timeNdx)}
                >
                  <RemoveCircleIcon fontSize='small' />
                </IconButton>
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default CustomHours;
